import React, { useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { appReducersActions } from "../store/reducers/app";
const Previews = () => {
  const dispatch = useDispatch();
  const { previewModal } = useSelector((state) => state.app);
  const viewer = useRef(undefined);
  const imgRef = useRef(undefined);

  const createViewer = useCallback(() => {
    if (!viewer.current) {
      viewer.current = new Viewer(imgRef.current, {
        fullscreen: false,
        navbar: false,
        toolbar: {
          zoomIn: true,
          zoomOut: true,
          oneToOne: true,
          reset: true,
          prev: false,
          next: false,
          rotateLeft: false,
          rotateRight: false,
          flipHorizontal: false,
          flipVertical: false,
        },
        title: false,
        exit() {
          dispatch(appReducersActions.setPreviewModal({ show: false }));
        },
      });
    }
  }, [dispatch]);

  useEffect(() => {
    if (previewModal.show && imgRef.current) {
      createViewer();
      viewer.current.show();
    }
  }, [previewModal, createViewer]);
  
  return (
    <div className={`previews-modal ${previewModal.show ? "show" : ""}`}>
      <img src={previewModal.url} ref={imgRef} alt=""></img>
    </div>
  );
};

export default Previews;
